import { createAgentServiceStore } from "@/store/modules/agentService";

/** 总客服仅装配GENERAL；复用协议代码而不复用订单Store状态、会话或业务锚点。 */
export default createAgentServiceStore({ sceneType: "GENERAL" });
